<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('InvoiceInboundsAccountant.title_same_as_menu')}}</strong>
                <span class="float-right">{{$t('InvoiceInboundsAccountant.text')}}</span>
                <div class="float-right">
                  <!--<router-link v-if="HelperRole.hasRights(state, [14],[16])" :to="{ path: '/invoiceinbound'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInbounds.new')}}</router-link>-->

                  <!--<router-link :to="{ path: '/invoiceinbound'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInbounds.new')}}</router-link>-->
                </div>
              </div>
              <div class="card-body card-block fColumn fColumn">


                <!--<div class="row form-group">-->
                <!--<div class="col col-md-3"><label for="select_year" class=" form-control-label">{{$t('selsells.selectYear')}}</label></div>-->
                <!--<div class="col-12 col-md-9">-->
                <!--<select id="select_year" v-model="selectedYear" class="form-control" name="selectedYear">-->
                <!--<option v-for="yearOption in yearOptions" :value="yearOption.value">{{yearOption.text}}</option>-->
                <!--</select>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="row form-group">-->
                <!--<div class="col col-md-3"><label for="select_month" class=" form-control-label">{{$t('selsells.selectMonth')}}</label></div>-->
                <!--<div class="col-12 col-md-9">-->
                <!--<select id="select_month" v-model="selectedMonth" class="form-control" name="selectedMonth">-->
                <!--<option v-for="monthOption in monthOptions" :value="monthOption.value">{{monthOption.text}}</option>-->
                <!--</select>-->
                <!--</div>-->
                <!--</div>-->

                <div class="row form-group">
                  <div class="col col-md-3"><label for="dt_from" class=" form-control-label">{{ $t('InvoiceInboundsAccountant.dt_from') }}
                    <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                  </div>
                  <div class="col-12 col-md-9">
                    <InputText type="DatetimepickerBp"
                               id="dt_from" name="data.dt_from" v-model="data2.dt_from" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                               :title="$t('InvoiceNavExport.dt_from')"
                               placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_from')"/>
                    <small class="form-text text-muted"></small>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col col-md-3"><label for="dt_to" class=" form-control-label">{{ $t('InvoiceInboundsAccountant.dt_to') }}
                    <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                  </div>
                  <div class="col-12 col-md-9">
                    <InputText type="DatetimepickerBp"
                               id="dt_to" name="data.dt_to" v-model="data2.dt_to" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                               :title="$t('InvoiceNavExport.dt_to')"
                               placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_to')"/>
                    <small class="form-text text-muted"></small>
                  </div>
                </div>

                <div class="fContent">
                  <TableDatatableJs :head="head" :data="data"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';
  import moment from 'moment';
  import InputText from '@/components/InputText.vue';

  import Api from '@/api/Api';
  import HelperRole from '@/helper/HelperRole';
  import AlertInPage from '@/components/AlertInPage.vue';

  export default {
    name: 'InvoiceInboundsAccountant',
    data() {
      const modul = this;
      // "id","id_company","text"
      return {
        data2: {
          dt_from: moment.utc().local().add(-1, 'month').format('YYYY-MM-DD'),
          dt_to: moment.utc().local().format('YYYY-MM-DD'),
        },
        year: "",
        yearOptions: [],
        month: "",

//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper
        ,
//        yearOptions: "",
//        monthOptions: "",
//
//        selectedYear: "",
//        selectedMonth: "",
//        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

        data: [],
        head: [
          {
            modulname: modul.name,
            title: "InvoiceInbounds.dttitle",
            data: "id",
            link: true,
            linkurl: "sbinvoiceinbound",
            linkclass: "text-nowrap",
            linkiconclass: "menu-icon fa fa-edit btn-link",
            linktext: "", // InvoiceInbounds.linktext
          }
          , {
            key: "text",
            title: "",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.text) {
                return "fa fa-info-circle nowrap rowcolorred";
              } else {
                return "";
              }
            },
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return ""
            },
          }


          , {
            xlsfield: true,
            key: "wf_status",
            i18Key: "InvoiceInbound.wf_statuses",
            title: "InvoiceInboundsAccountant.wf_status",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {

              if (dataRow.wf_status && dataRow.wf_status === "UPLOADING") {
                return "";
              }
              if (dataRow.wf_status && dataRow.wf_status === "ACCEPTED") {
                return "rowstgreen";
              }
              if (dataRow.wf_status && dataRow.wf_status === "REJECTED") {
                return "rowstgray";
              }
              return "";
//              if (Number(dataRow.price_sum) > 0) {
//              } else {
//              }

            },
          }
          , {
            xlsfield: true,
            key: "identifier",
            title: "Document.identifier",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {

              // a sumnum a képek hozzá feltöltött képek száma
              if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
                return "rowgreen";
              }
              if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
                return "rowyellow";
              }
              return "rowred";


//              if (HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 && dataRow.navdata) { //
//                  return "rowgreen";
//                }
//                if (( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 ) || dataRow.navdata) { //
//                  return "rowyellow";
//                }
//                return "rowred";
//              } else if (!HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
//                  return "rowgreen";
//                }
//                if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
//                  return "rowyellow";
//                }
//                return "rowred";
////                return "";
//
//              }
//              if (Number(dataRow.price_sum) > 0) {
//              } else {
//              }

            },
            searchField: true
          }


//
//          , {
//            xlsfield: true,
//            key: "wf_status",
//            i18Key: "InvoiceInbound.wf_statuses",
//            title: "InvoiceInbounds.wf_status",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//
//              if (dataRow.wf_status && dataRow.wf_status === "UPLOADING") {
//                return "";
//              }
//              if (dataRow.wf_status && dataRow.wf_status === "ACCEPTED") {
//                return "rowstgreen";
//              }
//              if (dataRow.wf_status && dataRow.wf_status === "REJECTED") {
//                return "rowstgray";
//              }
//              return "";
////              if (Number(dataRow.price_sum) > 0) {
////              } else {
////              }
//
//            },
//          }
//          , {
//            xlsfield: true,
//            key: "identifier",
//            title: "Document.identifier",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//
//              if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 && dataRow.navdata) { //
//                return "rowgreen";
//              }
//              if (( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 ) || dataRow.navdata) { //
//                return "rowyellow";
//              }
//              return "rowred";
////              if (Number(dataRow.price_sum) > 0) {
////              } else {
////              }
//
//            },
//            searchField: true
//          }
          , {
            xlsfield: true,
            searchField: true,
            key: "transfered",
            title: "InvoiceInbounds.transfered",
            i18Key: "global.yesno",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            xlsfieldNumber: true,
            searchField: true,
            key: "price_sum",
            title: "InvoiceInbounds.price_sum_in_huf",
            classtd: "text-right text-nowrap",
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return Helper.getFormattedPriceSegmentation(dataRowheadRowkey);
            },
          }
          , {
            xlsfield: true,
            xlsfieldNumber: true,
            searchField: true,
            key: "price_sum_net",
            title: "InvoiceInbounds.price_sum_net",
            classtd: "text-right text-nowrap",
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return Helper.getFormattedPriceSegmentation(dataRowheadRowkey);
            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "dt_make",
            title: "InvoiceInbounds.dt_make",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "dt_needtransfer",
            title: "InvoiceInbounds.dt_needtransfer",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            key: "payment_type",
            title: "Document.payment_type",
            searchField: true,
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.payment_type === "1") {
                return modul.$t('Document.paymenttype1');
              } else if (dataRow.payment_type === "2") {
                return modul.$t('Document.paymenttype2');
              } else if (dataRow.payment_type === "3") {
                return modul.$t('Document.paymenttype3');
              } else {
                return "";
              }
            },
            renderxls: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.payment_type === "1") {
                return modul.$t('Document.paymenttype1');
              } else if (dataRow.payment_type === "2") {
                return modul.$t('Document.paymenttype2');
              } else if (dataRow.payment_type === "3") {
                return modul.$t('Document.paymenttype3');
              } else {
                return "";
              }
            }
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "from_taxnumber",
            title: "Document.from_taxnumber",
          }
          , {
            xlsfield: true,
            searchField: true,
            key: "from_name",
            sortConvertType: "lowercase",
            title: "Document.from_businesspartnername",
          }
          ,
//
//          {
//            modulname: "InvoiceInboundsAccountant",
//            title: "InvoiceInbounds.dttitle",
//            data: "id",
//            link: true,
//            linkurl: "invoiceinbound",
//            linkclass: "text-nowrap",
//            linkiconclass: "menu-icon fa fa-edit btn-link",
//            linktext: "", // InvoiceInbounds.linktext
//          }
//          , {
//            key: "wf_status",
//            title: "InvoiceInbounds.wf_status",
//          }
//          , {
//            key: "identifier",
//            title: "Document.identifier",
//            searchField: true
//          }
//          , {
//            key: "price_sum",
//            title: "InvoiceInbounds.price_sum",
//          }
//          , {
//            key: "from_businesspartnername",
//            title: "Document.from_businesspartnername",
//          }
//          , {
//            key: "deleted",
//            title: "global.deleted",
//            searchField: true
//          }


        ]
        , breadcrumbstitle: 'InvoiceInbounds.title'
        , breadcrumbsData: [
          {
            'title': "InvoiceInbounds.title",
          },
        ]
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , timer: ""
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }

      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElements();
        }
      },

      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },
      'data2.dt_from': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal && newVal !== oldVal) {
            modul.$validator.validateAll().then((result) => {
              if (result) {
                modul.getElements();
              }
            });
          }
        }, 1000);
      },
      'data2.dt_to': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal && newVal !== oldVal) {
            modul.$validator.validateAll().then((result) => {
              if (result) {
                modul.getElements();
              }
            });
          }
        }, 1000);
      },

    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();

      const copiedState = Object.assign({}, modul.$store.state);
      const newState = Object.assign(copiedState, {lastVisitedListForRedirection: "invoiceinboundsaccountant"});
      modul.$store.replaceState(newState);

    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [19])) {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      setHead(){
        const modul = this;
        let head = [
          {
            modulname: "InvoiceInbounds",
            title: "InvoiceInbounds.dttitle",
            data: "id",
            link: true,
            linkurl: "sbinvoiceinbound",
            linkclass: "text-nowrap",
            linkiconclass: "menu-icon fa fa-edit btn-link",
            linktext: "", // InvoiceInbounds.linktext
          },
//          {
//            key: "identifier",
//            title: "Document.identifier",
//            searchField: true
//          }
//          ,
          {
            key: "id",
            title: "",
            celltype: "mark"
          }
          ,
          {
            key: "text",
            title: "",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.text) {
                return "fa fa-info-circle nowrap rowcolorred";
              } else {
                return "";
              }
            },
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return ""
            },
          }
          , {
            key: "text2",
            title: "InvoiceInbounds.text2",
            searchField: true,
            classth: "d-none",
            classtd: "d-none",
//            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
//                return "";
//            },
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return ""
            },
          }


          , {
            key: "recording_type",
            title: "InvoiceInbounds.recording_type",
            searchField: false,
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.recording_type === "H") {
                return modul.$t("InvoiceInbounds.H");
              } else if (dataRow.recording_type === "N") {
                return modul.$t("InvoiceInbounds.N");
              } else {
                return ""
              }
            },
          }
          ,
          {
            xlsfield: true,
            key: "wf_status",
            i18Key: "InvoiceInbound.wf_statuses",
            title: "InvoiceInboundsAccountant.wf_status",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {

              if (dataRow.wf_status && dataRow.wf_status === "UPLOADING") {
                return "";
              }
              if (dataRow.wf_status && dataRow.wf_status === "ACCEPTED") {
                return "rowstgreen";
              }
              if (dataRow.wf_status && dataRow.wf_status === "REJECTED") {
                return "rowstgray";
              }
              return "";
//              if (Number(dataRow.price_sum) > 0) {
//              } else {
//              }

            },
            searchField: true
          }
          , {
            xlsfield: true,
            key: "identifier",
            title: "Document.identifier",
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {

              // a sumnum a képek hozzá feltöltött képek száma
              if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
                return "rowgreen";
              }
              if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
                return "rowyellow";
              }
              return "rowred";
//
//              if (HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 && dataRow.navdata) { //
//                  return "rowgreen";
//                }
//                if (( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0 ) || dataRow.navdata) { //
//                  return "rowyellow";
//                }
//                return "rowred";
//              } else if (!HelperRole.hasRights(modul.state, [15], false)) {
//                if (dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) > 0) { //
//                  return "rowgreen";
//                }
//                if (dataRow.sumnum === null || ( dataRow.sumnum && !isNaN(Number(dataRow.sumnum)) && Number(dataRow.sumnum) === 0 )) { //
//                  return "rowyellow";
//                }
//                return "rowred";
//              }
//              if (Number(dataRow.price_sum) > 0) {
//              } else {
//              }

            },
            searchField: true
          }
        ];
        const headCashSettlement = [
          // state.settings.cash_settlement

          {
            key: "id",
            title: "global.edit",
            searchField: false
            , roweditor: true
            , cbSave: function (e, index, headRow, dataRow) {
            return new Promise((resolve, reject) => {

              const data = {};
              data.is_priceincludedtovat = dataRow.is_priceincludedtovat;
              data.dt_priceincludedtovat = dataRow.dt_priceincludedtovat;
              data.is_processedbyaccountant = dataRow.is_processedbyaccountant;

              const req = {};
              req.id = dataRow.id;
              req.data = data;
              req.id_company = modul.state.id_company;

              modul.AlertInPage.msg = "form.in_progress";
              modul.AlertInPage.type = "warning";
              Api.saveInvoiceInboundExtrafields(req).then(function (res) {
                modul.AlertInPage.msg = "";
                if (res && res.result && res.data && res.data.id) {
                  modul.AlertInPage.msg = "form.save_succes";
                  modul.AlertInPage.type = "success";
                  setTimeout(function (e) {
                    modul.AlertInPage.msg = "";
                  }, Number(modul.AlertInPage.delay));
                  resolve();
                } else {
                  modul.AlertInPage.msg = "form.save_error";
                  modul.AlertInPage.type = "danger";
                  setTimeout(function (e) {
                    modul.AlertInPage.msg = "";
                  }, Number(modul.AlertInPage.delay));
                  reject();
                }
              }, function (e) {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
                reject();
              });

            })
          },

          }
          ,{
            key: "is_priceincludedtovat",
            title: "InvoiceOutbounds.is_priceincludedtovat",
            searchField: true
            ,editable: true
            ,rowedittype:"checkbox"
          }
          , {
            key: "dt_priceincludedtovat",
            title: "InvoiceOutbounds.dt_priceincludedtovat",
            searchField: true,
            xlsfield: true
            , editable: true
            , rowedittype: "datetimepicker"
          }
          , {
            key: "is_processedbyaccountant",
            title: "InvoiceOutbounds.is_processedbyaccountant",
            searchField: true,
            xlsfield: true
            , editable: true
            , rowedittype: "checkbox"
          }
        ];
        const head3 = [

          {
            xlsfield: true,
            xlsfieldNumber: true,
            xlsrender: false,
            searchField: true,
            key: "price_sum",
            title: "InvoiceInbounds.price_sum_act_dev",
            sortConvertType: "number",
            classtd: "text-right text-nowrap",
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              let user_sumprice_huf_number_of_decimals = (Number(modul.user_sumprice_huf_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_huf_number_of_decimals) : 0;
              let user_sumprice_eur_number_of_decimals = (Number(modul.user_sumprice_eur_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_eur_number_of_decimals) : 2;
              let user_sumprice_usd_number_of_decimals = (Number(modul.user_sumprice_usd_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_usd_number_of_decimals) : 2;

              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_huf_number_of_decimals) {
                user_sumprice_huf_number_of_decimals = modul.state.usersettings.user_sumprice_huf_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_eur_number_of_decimals) {
                user_sumprice_eur_number_of_decimals = modul.state.usersettings.user_sumprice_eur_number_of_decimals
              }
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_usd_number_of_decimals) {
                user_sumprice_usd_number_of_decimals = modul.state.usersettings.user_sumprice_usd_number_of_decimals
              }
              let ret = "";
              if (dataRow.currency === "HUF") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sum"], user_sumprice_huf_number_of_decimals)
              } else if (dataRow.currency === "EUR") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sum_currency"], user_sumprice_eur_number_of_decimals)
              } else if (dataRow.currency === "USD") {
                ret = Helper.getFormattedPriceSegmentation(dataRow["price_sum_currency"], user_sumprice_usd_number_of_decimals)
              }
              return ret;
            },
            renderxls: function (dataRowheadRowkey, type, dataRow, meta) {
              let ret = "";
              if (dataRow.currency === "HUF") {
                ret = dataRow["price_sum"]
              } else if (dataRow.currency === "EUR") {
                ret = dataRow["price_sum_currency"]
              } else if (dataRow.currency === "USD") {
                ret = dataRow["price_sum_currency"]
              }
              return ret;
            },
          }
          , {
            key: "currency",
            xlsfield: true,
            searchField: true,
            title: "InvoiceInbounds.currency",
          },



          {
            key: "dt_make",
            title: "InvoiceInbounds.dt_make",
            searchField: true,
            xlsfield: true,
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            key: "dt_paymentdeadline",
            title: "InvoiceInbounds.dt_paymentdeadline",
            searchField: true,
            xlsfield: true,
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            key: "dt_completion",
            title: "InvoiceInbounds.dt_completion",
            searchField: true,
            xlsfield: true,
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            },
          }
          , {
            xlsfield: true,
            key: "payment_type",
            title: "Document.payment_type",
            searchField: true,
            i18Key: "Document.paymenttypeObject",

            render: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.payment_type === "1") {
                return modul.$t('Document.paymenttype1');
              } else if (dataRow.payment_type === "2") {
                return modul.$t('Document.paymenttype2');
              } else if (dataRow.payment_type === "3") {
                return modul.$t('Document.paymenttype3');
              } else {
                return "";
              }
            },
            renderxls: function (dataRowheadRowkey, type, dataRow, meta) {
              if (dataRow.payment_type === "1") {
                return modul.$t('Document.paymenttype1');
              } else if (dataRow.payment_type === "2") {
                return modul.$t('Document.paymenttype2');
              } else if (dataRow.payment_type === "3") {
                return modul.$t('Document.paymenttype3');
              } else {
                return "";
              }
            },
          }

          , {
            key: "from_taxnumber",
            title: "Document.to_taxnumber",
            searchField: true,
            xlsfield: true,
          }
          , {
            key: "from_name",
            title: "Document.to_businesspartnername",
            sortConvertType: "lowercase",
            searchField: true,
            xlsfield: true,
          }
          ,{
            key: "dt_transfer",
            title: "InvoiceInbounds.dt_transfer",
            searchField: true,
            xlsfield: true,
            cbclasstd: function (dataRowheadRowkey, type, dataRow, meta) {
              return "text-nowrap";
            }
          }


        ];

        head = head.concat(head3);
        if (modul.state.settings && modul.state.settings.cash_settlement && Helper.String(modul.state.settings.cash_settlement) === "1") {
          head = head.concat(headCashSettlement);
        }
        modul.head = head;
        console.log(modul.head);
      },
      init(){
        const modul = this;
        this.setYearsMonths();
//        modul.getElements();
        modul.setHead();
      },
      setYearsMonths(){
        const modul = this;
        const actualYears = [moment().get("year"), moment().get("year") - 1, moment().get("year") - 2];
        const actualMonth = moment().get("month") + 1;
//                const actualYears = [moment.utc().get("year"), moment.utc().get("year") - 1, moment.utc().get("year") - 2];
//                const actualMonth = moment.utc().get("month") + 1;
        const yearOptions = [];
        Array.prototype.forEach.call(actualYears, function (e) {
          yearOptions.push({'value': e, 'text': e});
        });
        const selectedYear = "" + actualYears[0];
        const selectedMonth = "" + actualMonth;
        modul.yearOptions = yearOptions;
//                modul.year = selectedYear;
//                modul.month = selectedMonth;

        const actualDt2 = moment();
//        actualDt2.subtract('months', 1);
//        actualDt2.set('date', 1);
//        actualDt2.set('hour', 0);
//        actualDt2.set('minute', 0);
//        actualDt2.set('second', 0);
//        actualDt2.set('millisecond', 0);
        modul.data2.dt_from = actualDt2.clone().subtract('months', 3).format('YYYY-MM-DD HH:mm:ss');
        modul.data2.dt_to = actualDt2.clone().format('YYYY-MM-DD HH:mm:ss'); // .endOf('month')
        modul.year = actualDt2.get("year");
        modul.month = actualDt2.get("month");
      },

//      setYearsMonths(){
//        const modul = this;
//        const actualYears = [moment().get("year"), moment().get("year") - 1, moment().get("year") - 2];
//        const actualMonth = moment().get("month") + 1;
//        modul.yearOptions = [];
//        Array.prototype.forEach.call(actualYears, function (e) {
//          modul.yearOptions.push({'value': e, 'text': e});
//        });
//        modul.generateMonthNameOptions();
//        modul.selectedYear = actualYears[0];
//        modul.selectedMonth = actualMonth;
//      },
//      generateMonthNameOptions(){
//        const modul = this;
//        modul.monthOptions = [];
//        Array.prototype.forEach.call(modul.months, function (e) {
//          modul.monthOptions.push({'value': e, 'text': modul.$t('monthNamesList.' + e)});
//        });
//      },
//      modulRowIdCb: function (data, type, row, meta) {
//        const modul = this;
//        console.log("--" + data);
//        return "" + row.identifier_pre_id + row.identifier_counter;
//      },
//      renderType(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return modul.$t("global.contacttype.businesspartner")
//        }
//        if (Number(row.id_store)>0) {
//          return modul.$t("global.contacttype.store")
//        }
//        if (Number(row.id_address)>0) {
//          return modul.$t("global.contacttype.address")
//        }
//      },
//      renderEntity(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return row.businesspartnerbusinesspartnername;
//        }
//        if (Number(row.id_store)>0) {
//          return row.storetext;
//        }
//        if (Number(row.id_address)>0) {
//          return row.addressname;
//        }
//      },
//      chkRole(){
//        const modul = this;
//        modul.hasRole = false;
//        const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
//        if (!Helper.checkRoles(modul.roles, role)) {
//          modul.hasRole = false;
////        modul.$router.push({name: "dashboard"})
//        } else {
//          modul.hasRole = true;
//        }
//      },
      getElements(){
        const modul = this;
        modul.setHead();

        const data = {
          dt_from: modul.data2.dt_from,
          dt_to: modul.data2.dt_to,
        };
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getInvoiceInboundsAccountant({id_company: modul.$store.state.id_company, data: data}).then(function (res) {
          modul.AlertInPage.msg = "";
          if (res && res.result) {
            modul.data = Array.from(res.data);
          } else {
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }

//          const res = result;
//          modul.data = Array.from(result);
          console.log(res);

        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });

      }
    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      InputText,
      AlertInPage,
    },
  };
</script>


<style @scoped="">
  .rowcolorred{
  color: red;
  }
  .rowred{
  background-color: #dc3545;
  }
  .rowgreen{
  background-color: #28a745;
  }
  .rowyellow{
  background-color: #ffc107;
  }
  .rowblue{
  background-color: #007bff;
  }
  .rowstwhite{ background-color: var(--white);}
  .rowstgreen{ background-color: var(--green);}
  .rowstgray{ background-color: var(--gray);}

</style>






